
import React, { useState } from "react";

import Header from "../components/home/header";
import SidebarComponent from './SidebarComponent';
import { GoogleAd } from '../components/ads/GoogleAd';
import { useScreen } from '../contexts/screen.provider';
import { ContactForm } from './contact-us';
import { useAppSelector } from "../redux/hooks";


function ContactUsPage() {

  const user = useAppSelector(state => state.auth.user)
  const [displaySidebar, setDisplaySidebar] = useState(false);
  const { isMobile, isDesktop } = useScreen()

  function changeSidebarDisplay() {
    setDisplaySidebar((prev) => !prev);
  }



  return (
    <div className="w-full overflow-y-auto  h-screen custom-scrollbar  bg-white dark:bg-[#202020] flex flex-col ">
      <Header
        isAdsVisible={true}
        sidebarDisplay={displaySidebar}
        changeSidebarDisplay={changeSidebarDisplay} />
      <main className="flex mt-[6vh] md:mt-[7vh] tablet:mt-[10vh] gap-2  tablet:px-4 px-2    flex-col items-center tablet:items-start   tablet:flex-row flex-grow relative">
        {user && <SidebarComponent setSidebarDisplay={setDisplaySidebar} sidebarDisplay={displaySidebar} />}
        {!isMobile && <GoogleAd />}
        <ContactForm />
        {
          isDesktop
            ?
            <GoogleAd />
            :
            <div className="h-full w-full ">
              <GoogleAd />
            </div>
        }
      </main>
    </div>

  )
}

export default ContactUsPage
